import React, {
    useState,
    useEffect,

} from "react"
import { Tabs, Badge } from './ot'

const BaseCardView1_6 = ({
    badges = [
        {
            label: "王小明",
            variant: "outline",
            className: ""
        },
        {
            label: <><svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <rect width="18" height="18" x="3" y="3" rx="2" ry="2" />
                <path d="M8 11h8" />
                <path d="M8 15h8" />
                <path d="M8 7h8" />
            </svg>2025-05-30</>,
            variant: "outline",
            className: ""
        },
    ],
    containerClassName = "flex flex-wrap gap-2 mt-3",
    badgeClassName = "",
}, ref) => {
    return (
        <div className={containerClassName}>
            {badges.map((value, index) => {
                return <Badge key={index} className={`${badgeClassName} ${value?.className || ""}`.trim()} variant={value?.variant}>{value?.label}</Badge>
            })}
        </div>
    )
}

export default BaseCardView1_6
